<template>
  <div id="map-container" class="map-container">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import leafletImage from "leaflet-image";
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [24, 36],
  iconAnchor: [12, 36],
});

L.Marker.prototype.options.icon = DefaultIcon;

export default {
  name: "DeviceRoutes",
  props: {
    stats: Object,
  },
  components: {
    Loading,
  },
  data() {
    return {
      // url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      url: "http://www.google.cn/maps/vt?lyrs=p@189&gl=tr&x={x}&y={y}&z={z}",
      bounds: null,
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
        preferCanvas: true,
      },
      startPosition: { lat: 0, lng: 0 },
      endPosition: { lat: 0, lng: 0 },
      isLoading: false,
      fullPage: true,
      map: "",
      polyline: [],
    };
  },
  mounted() {
    this.initialiseMap();
  },
  watch: {
    stats: {
      handler: function() {
        // this.isLoading = true;
        this.initialiseMap();
        // console.log("stats changed");

        // console.log(this.dataUrl, "dataurl");
      },
      deep: true,
      immediate: true,
    },
    // endPosition: {
    //   handler: function() {
    //     this.map = L.map('map-container', this.mapOptions).setView(
    //       this.endPosition,
    //       15
    //     );
    //   },
    //   deep: true,
    // },
  },
  methods: {
    initialiseMap() {
      
      if (this.map !== "") {
        this.map.remove();
      }
      this.$nextTick(() => {
        this.map = L.map("map-container", this.mapOptions).setView(
          [38.88995, -77.00906],
          15
        );
        var layer = new L.TileLayer(this.url);
        this.map.addLayer(layer);
        if (this.stats?.waypoints?.length === 0) return;
        let bounds;
        if (this.stats?.waypoints && this.stats?.waypoints?.length > 0) {
          this.startPosition = {
            ...this.stats.start,
          };
          this.endPosition = {
            ...this.stats.end,
          };
          bounds = [];
          for (let i = 0; i < this.stats?.waypoints?.length; i++) {
            bounds.push([
              this.stats.waypoints[i].latitude,
              this.stats.waypoints[i].longitude,
            ]);
          }
        } else {
          bounds = [
            [6.50081290280357, 3.46963806152345],
            [7.02991732677597, 3.38716201782228],
          ];
        }

        let startMarker = L.marker(this.startPosition).addTo(this.map);
        let endMarker = L.marker(this.endPosition)
          .bindTooltip(this.$t("end"), { permanent: true })
          .addTo(this.map);
        startMarker.bindTooltip(this.$t("start"), {
          permanent: true,
          direction: "right",
        });

        startMarker.openTooltip();
        endMarker.openTooltip();

        this.map.setView(this.endPosition, 18);

        // start of routes
        this.map.removeLayer(this.polyline);

        this.polyline = L.polyline(bounds, { color: "#213e7a" }).addTo(
          this.map
        );

        // zoom the map to the polyline
        this.map.fitBounds(this.polyline.getBounds());

        // End of routes part

        // Export Image of Map
        // leafletImage(this.map, doImage);

        // var dataUrl;

        // var dimensions = this.map.getSize();

        // function doImage(err, canvas) {
        //   var img = document.createElement("img");
        //   img.width = dimensions.x;
        //   img.height = dimensions.y;
        //   img.src = canvas.toDataURL();
        //   setTimeout(() => {
        //     dataUrl = img.src;
        //   }, 1000);
        // }
        // setTimeout(() => {
        //   // console.log(dataUrl, "url after function");
        //   this.isLoading = false;
        //   this.$emit("dataUrl", dataUrl);
        // }, 500);
      });
    },
  },
};
</script>

<style scoped>
.map-container {
  height: 100%;
}
</style>

<i18n>
{}
</i18n>
